<template>
  <g-dialog
    v-model="dialog"
    title="Plan Summary & Add-Ons"
    :action-buttons="actions"
    height="600"
    @cancel="onCancel"
  >
    <AddonSelector
      v-if="shouldRender"
      ref="selector"
      v-model="value"
      :annual-billing="annualBilling"
      :show-coupon-disclaimer="showCouponDisclaimer"
      :show-addon-prices="true"
      :include-plan-price="includePlanPrice"
      :plan-id="addonTarget"
      :price-override="priceOverride"
    />
  </g-dialog>
</template>

<script>
import GDialog from '../generic/GDialog.vue';
import AddonSelector from './AddonSelector.vue';
import { SMART_PLAN } from './data/constants';

export default {
  name: 'AddonDialog',
  components: {
    GDialog,
    AddonSelector,
  },

  props: {
    annualBilling: {
      type: Boolean,
      default: true,
    },

    showCouponDisclaimer: {
      type: Boolean,
      default: true,
    },

    show: {
      type: Boolean,
      default: false,
    },

    includePlanPrice: {
      type: Boolean,
      default: true,
    },

    value: {
      type: Object,
      default: null,
    },

    addonTarget: {
      type: String,
      default: SMART_PLAN,
    },

    priceOverride: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      actions: [{
        name: 'CANCEL',
        type: 'default',
        side: 'right',
        onClick: this.onCancel,
      }, {
        name: 'CONTINUE TO PAYMENT',
        type: 'primary',
        side: 'right',
        mustValidate: true,
        onClick: this.onContinue,
      }],
      shouldRender: true,
    };
  },

  computed: {
    frequency() {
      return this.annualBilling ? 'year' : 'month';
    },

    dialog: {
      get() {
        return this.show;
      },
      set() {},
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.shouldRender = false;
        this.$nextTick(() => {
          this.shouldRender = true;
        });
      }
    },
  },

  methods: {
    onCancel() {
      this.$emit('cancel');
    },

    onContinue() {
      const { selectedAddons } = this.$refs.selector;
      this.$emit('continue', selectedAddons, this.$refs.selector.currency);
    },
  },
};
</script>
